const e = {
  name: "NewZealand",
  dimensions: { width: 20, height: 20 },
  content: `
    <g>
      <path d="M12 18.4625C15.5899 18.4625 18.5 15.5524 18.5 11.9625C18.5 8.37267 15.5899 5.46252 12 5.46252C8.41015 5.46252 5.5 8.37267 5.5 11.9625C5.5 15.5524 8.41015 18.4625 12 18.4625Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.5 9.46252C3.29 9.46252 1.5 7.67252 1.5 5.46252C1.5 3.25252 3.29 1.46252 5.5 1.46252C7.71 1.46252 9.5 3.25252 9.5 5.46252" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.5 6.46252C5.05228 6.46252 5.5 6.01481 5.5 5.46252C5.5 4.91024 5.05228 4.46252 4.5 4.46252C3.94772 4.46252 3.5 4.91024 3.5 5.46252C3.5 6.01481 3.94772 6.46252 4.5 6.46252Z" fill="currentColor" stroke="none"/>
      <path d="M2.5 8.46252L1.5 13.4625" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  e as NewZealand
};
